export default "/images/04b2084bdd7e70a97358dea76bef1af5.avif";